@if (betaaltransactie) {
    <transaction-result [transactionStatus]="betaaltransactie.status"> </transaction-result>
}

@if (nextBestAction && !nbaLoading) {
    <section class="ap-justify-content-center ap-flex ap-grid-full-bleed">
        <div class="ap-text-align-center" data-bb="nba-container">
            <h2>{{ nextBestAction.title }}</h2>
            <p [innerHTML]="nextBestAction.text" class="nba-text"></p>
            <ap-button (onClick)="nbaClicked()" class="nba-button">{{ nextBestAction.linkText }}</ap-button>
        </div>
    </section>
}
